const universalPrefix = window.location.pathname.startsWith('/2') ? '/2' : '';
const oldFrontendPrefix = '';
function complex(config) {
    const prefix = config.prefix ?? oldFrontendPrefix;
    return {
        prefix,
        path: `${prefix}${config.path}`,
        url: (...args) => `${prefix}${config.url(...args)}`,
    };
}
export const AppRoutes = {
    search: {
        therapist: complex({
            prefix: universalPrefix,
            path: `/suche/:cityslug`,
            url(city, searchParams) {
                const params = new URLSearchParams();
                const page = searchParams?.page ?? 1;
                if (page > 1) {
                    params.set('page', String(page));
                }
                if (searchParams?.sort) {
                    params.set('sort', searchParams.sort);
                }
                searchParams?.therapeuticFocus?.forEach(focus => {
                    params.append('therapeuticFocus', focus);
                });
                searchParams?.treatmentMethods?.forEach(method => {
                    params.append('treatmentMethods', method);
                });
                searchParams?.jobTitleTypes?.forEach(jobTitle => {
                    params.append('jobTitleTypes', jobTitle);
                });
                searchParams?.languages?.forEach(lang => {
                    params.append('languages', lang);
                });
                searchParams?.coverageTypes?.forEach(coverage => {
                    params.append('coverageTypes', coverage);
                });
                searchParams?.gender?.forEach(gender => {
                    params.append('gender', gender);
                });
                searchParams?.location?.forEach(location => {
                    params.append('location', location);
                });
                if (params.size > 0) {
                    return `/suche/psychotherapeuten-in-${city}?${params.toString()}`;
                }
                return `/suche/psychotherapeuten-in-${city}`;
            },
        }),
    },
};
//# sourceMappingURL=AppRoutes.mjs.map